import { render, staticRenderFns } from "./editShopDialog.vue?vue&type=template&id=60264f32&scoped=true"
import script from "./editShopDialog.vue?vue&type=script&lang=js"
export * from "./editShopDialog.vue?vue&type=script&lang=js"
import style0 from "./editShopDialog.vue?vue&type=style&index=0&id=60264f32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60264f32",
  null
  
)

export default component.exports